import { UserFull } from '@wellesley/openapi'
import { getRoute } from '@wellesley/router'

type GetGroupChannelPathProps = {
  groupName: string
  channel: Pick<UserFull, 'groupUserName'>
  type?: 'profile' | 'settings'
  tab?: string
}
export const getGroupChannelPath = ({
  groupName,
  channel,
  type = 'profile',
  tab = '',
}: GetGroupChannelPathProps) => {
  if (type === 'settings') {
    return getRoute(`/g/:groupname/@/:channelname/settings/:tab?`, {
      groupname: groupName,
      channelname: channel.groupUserName,
      tab,
    })
  }

  return getRoute(`/g/:groupname/@/:channelname/:tab?`, {
    groupname: groupName,
    channelname: channel.groupUserName,
    tab,
  })
}
